<script setup>
// The draft's one action, pinned under the scrolling draft (Grant 2026-11-03: "Review and apply needs to be fixed at the
// bottom of the Draft popup, it's hidden below the scroll at the minute"): the dock's foot slot holds this, outside the
// body that scrolls, so the button shows at every viewport height, phone width included (TlDialog's own body + foot shape).
// X64 (Grant: "no option to actually publish the updates after?"): the button says what comes next. "Review and apply"
// once the assistant says the draft is ready, "Check the draft" before, "See what changed" once applied.
import {computed} from 'vue';
import {applyButtonLabel, draftCheckLabel} from '~/utils/setupAssistant';

const props = defineProps({
  proposal: {type: Object, default: null},
  busy: {type: Boolean, default: false},
  /** X64: the proposal was applied; the button opens the done page. */
  applied: {type: Boolean, default: false},
  /** X121 (R55 L1): the applied proposal was undone; never "live". */
  undone: {type: Boolean, default: false},
  /** X119 (R54 L3): what the club has live, so the hint names the check page's button ("Create setup" / "Apply now") exactly. */
  availability: {type: Object, default: null},
});
const emit = defineEmits(['check']);

const steps = computed(() => props.proposal?.steps ?? []);
const checkLabel = computed(() => (props.applied || props.undone ? 'See what changed' : draftCheckLabel(props.proposal)));
const primary = computed(() => props.applied || !!props.proposal?.ready);
const applyWord = computed(() => applyButtonLabel(props.proposal, props.availability));
</script>

<template>
  <div v-if="steps.length" class="sdp-foot" data-testid="setup-draft-foot">
    <v-btn :color="primary ? 'primary' : undefined" :variant="primary ? 'flat' : 'outlined'" block :disabled="busy" data-testid="setup-draft-check" @click="emit('check')">
      {{ checkLabel }}
    </v-btn>
    <div v-if="undone" class="sdp-foot-hint">This setup was undone. The done page lists what was put back.</div>
    <div v-else-if="applied" class="sdp-foot-hint">These changes are live. The done page has what changed, the next steps and Undo.</div>
    <div v-else-if="proposal?.ready" class="sdp-foot-hint">Nothing is live yet. Review it, then press {{ applyWord }} on the next page.</div>
    <div v-else class="sdp-foot-hint">You can check the draft at any time; the assistant may still have questions.</div>
  </div>
</template>

<style scoped lang="scss">
/* TlDialog's foot: a hairline above, pinned under the scrolling body; the phone sheet keeps it above the home indicator */
.sdp-foot {
  padding: 12px 16px;
  border-top: 1px solid rgb(var(--v-theme-borderLight));
  background: rgb(var(--v-theme-surface));

  @media (max-width: 599px) {
    padding-bottom: calc(12px + env(safe-area-inset-bottom));
  }
}

.sdp-foot-hint { font-size: 11.5px; color: rgb(var(--v-theme-textSubtle)); margin-top: 6px; text-align: center; }
</style>
